import Cookies from 'js-cookie'
import { getBankLists } from "@/api/bank";
import { unallocatedAll, allFlagType, getOkxParam } from "@/api/app";

export default {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    bankLists: [],
    bankListsParams: {}, // bankLists 的参数也存起来用以判断不同情况是否需要再次请求接口

    // 红点泡泡
    reloadTime: 0,
    unallocatedObj: {},
    intervalTime: 10000, // 豪秒数

    // Okx参数
    okxParamObj: {
      paymentMethodInfoList: [], // 汇率抓取方式
      tierInfoList: [] // 抓取档位
    }
  },
  mutations: {
    SET_STATE: (state, data) => {
      Object.keys(data).forEach(key => {
        state[key] = data[key]
      })
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    }
  },
  actions: {
    /* 取得左侧菜单泡泡数量
    */
    GetUnallocatedAll({ commit }) {
      // DFtest
      // unallocatedAll().then((res) => {
      //   commit('SET_STATE', {
      //     unallocatedObj: res ? res.data : {}
      //   });
      // });
    },
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    /* 取得银行列表，以利缓存 bankLists
    */
    ToggleBankLists({ commit, state }, params) {
      params = params ? params : {};
      // 注意每个页面可能请求参数不同，若是参数改变需要再次请求
      // if (state.bankLists.length > 0 && JSON.stringify(params) === JSON.stringify(state.bankListsParams)) { // 做缓存用
      if (false) { // 暂时不做缓存
        return state.bankLists;
      } else {
        return new Promise((resolve, reject) => {
          getBankLists(params).then(res => {
            // commit('SET_STATE', { bankListsParams: params })
            // 设定 state 资料
            commit('SET_STATE', { bankLists: res.data })
            resolve(state.bankLists)
          }).catch(err => {
            reject(err)
          })
        })
      }
    },
    // 获取所有注记类型
    GetAllFlagType() {
      return new Promise((resolve, reject) => {
        allFlagType().then((res) => {
          const data = res.data.map((res) => ({
            label: res.message,
            value: res.code,
          }));
          data.unshift({ label: "【空注记】", value: "" });
          resolve(data);
        }).catch(() => {
          reject([])
        })
      });
    },
    // Okx参数
    GetOkxParam({ commit, state }) {
      if (state.okxParamObj.paymentMethodInfoList.length > 0 || state.okxParamObj.tierInfoList.length > 0) { // 做缓存用
        return state.okxParamObj;
      } else {
        return new Promise((resolve, reject) => {
          getOkxParam().then(res => {
            commit('SET_STATE', { okxParamObj: res.data })
            resolve(state.okxParamObj)
          }).catch(err => {
            reject(err)
          })
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js